// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_Tpc","cls2":"Reader-cls2_maf Reader-cls1_Tpc"};